define('lq/services/action/addToHomeScreenCommand',[
    'lq/responsive'
], function (responsive) {
    'use strict';

    function AddToHomeScreenCommand(data, rootDrop) {
        this.data = data;
        this.rootDrop = rootDrop;
    };

    AddToHomeScreenCommand.typeName = 'AddToHomeScreenCommand';

    AddToHomeScreenCommand.deferredPrompt = null;

    AddToHomeScreenCommand.prototype.initialize = function () {
        if (!responsive.isPWA()) {
            // Running in Browser
            AddToHomeScreenCommand.deferredPrompt = this.rootDrop.piping.deferredPrompt;
        } else {
            // Running as PWA
            var self = this;
            var eventName = 'alreadyAdded';
            setTimeout(function () {
                if (self.rootDrop.piping.eventing && self.data.eventing[eventName] && self.data.eventing[eventName].enabled) {
                    self.rootDrop.piping.eventing.publish(self.data.eventing[eventName].raisedEventName, null, null, null, self.eventActionId);
                }
            });
        }
    };

    AddToHomeScreenCommand.prototype.dispose = function () {
        this.rootDrop = undefined;
    };

    return AddToHomeScreenCommand;
});

